// Load but disable Turbo by default
import * as Turbo from "@hotwired/turbo"
Turbo.session.drive = false
